<template>
  <div id="app">
    <header ref="header">
      <div class="container">
        <a href="./">
          <img :src="require('@/assets/image/logo.svg')" alt="" class="logo">
        </a>
      </div>
    </header>
    <main>
      <v-main-section ref="mainSection"/>
      <v-twenty-section/>
      <v-cinema-section/>
      <v-spotify-section/>
      <v-mars-section/>
      <v-generation-section/>
      <v-world-section/>
      <v-plastic-section/>
      <v-sim-section/>
      <v-youtube-section/>
      <v-console-section/>
      <v-eco-section/>
      <v-footer-section/>
    </main>
  </div>
</template>

<script>
import { gsap, TweenMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import vMainSection from '@/components/v-main-section.vue';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'App',
  components: {
    vMainSection,
    vTwentySection: () => import('@/components/v-twenty-section.vue'),
    vCinemaSection: () => import('@/components/v-cinema-section.vue'),
    vSpotifySection: () => import('@/components/v-spotify-section.vue'),
    vMarsSection: () => import('@/components/v-mars-section.vue'),
    vGenerationSection: () => import('@/components/v-generation-section.vue'),
    vWorldSection: () => import('@/components/v-world-section.vue'),
    vPlasticSection: () => import('@/components/v-plastic-section.vue'),
    vSimSection: () => import('@/components/v-sim-section.vue'),
    vYoutubeSection: () => import('@/components/v-youtube-section.vue'),
    vConsoleSection: () => import('@/components/v-console-section.vue'),
    vEcoSection: () => import('@/components/v-eco-section.vue'),
    vFooterSection: () => import('@/components/v-footer-section.vue'),
  },
  metaInfo: {
    title: 'МТС 2021 — с Новым Годом!',
    titleTemplate: '%s | 2021.mts.ru',
    htmlAttrs: {
      lang: 'ru',
    },
    meta: [
      {
        name: 'description',
        content: 'МТС 2021',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no',
      },
      {
        property: 'og:title',
        content: 'МТС 2021',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:image',
        content: './open_g.jpg',
      },
      {
        property: 'og:image:type',
        content: 'image/jpeg',
      },
      {
        property: 'og:image:width',
        content: '1024',
      },
      {
        property: 'og:image:height',
        content: '512',
      },
      {
        property: 'og:url',
        content: 'https://2021.mts.ru/',
      },
    ],
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    if (vh < 5) vh = 5;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // window.addEventListener('resize', () => {
    //   let vhResize = window.innerHeight * 0.01;
    //   if (vhResize < 5) vhResize = 5;
    //   document.documentElement.style.setProperty('--vh', `${vhResize}px`);
    // });
    TweenMax.from(
      this.$refs.header, 3, {
        y: '-10px',
        delay: 1,
        autoAlpha: 0,
        ease: 'expo.out',
      },
    );
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss">
#app {

}

.logo{
  display: block;
  margin: 0 auto;
}
header{
  background-color: $primary;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;

  .container{
    padding: 15px 0;
  }
}
</style>
